var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useHistory } from 'react-router-dom';
import { CRUD_DELETE, useDelete, useTranslate } from 'ra-core';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import { EditButton, TopToolbar } from 'react-admin';
import { Show } from '../ui';
import { ApplicationDetails } from './ApplicationDetails';
import { ApplicationTitle } from './ApplicationTitle';
import { isEditApplicationDisabled } from './isApplicationPending';
import { useUserContext } from '../userContexts';
import { useLayer7Notify } from '../useLayer7Notify';
import { ConfirmDialog } from '../ui/ConfirmDialog';
import { LoadingDialog } from '../ui/LoadingDialog';
const useContentStyles = makeStyles(theme => ({
    label: {
        color: theme.palette.secondary.darkBlue,
    },
}));
const AppShowActions = ({ basePath, data, resource, userContext, className, }) => {
    const [canEdit, setCanEdit] = React.useState(false);
    const [canDelete, setCanDelete] = React.useState(false);
    const [deleteConfirm, setDeleteConfirm] = React.useState(false);
    const translate = useTranslate();
    const notify = useLayer7Notify();
    const contentLabelClasses = useContentStyles();
    const history = useHistory();
    const [deleting, setDeleting] = React.useState(false);
    React.useEffect(() => {
        if (data && !isEditApplicationDisabled(userContext, data)) {
            setCanEdit(true);
        }
        else {
            if (canEdit)
                setCanEdit(false);
        }
    }, [canEdit, data, userContext]);
    React.useEffect(() => {
        if (data && userContext) {
            if (data.status !== 'EDIT_APPLICATION_PENDING_APPROVAL' &&
                !userContext.userDetails.developer) {
                setCanDelete(true);
            }
            else {
                if (canDelete)
                    setCanDelete(false);
            }
        }
    }, [canDelete, data, userContext]);
    const [deleteApplication] = useDelete('applications', data === null || data === void 0 ? void 0 : data.id, data, {
        action: CRUD_DELETE,
        onSuccess: () => {
            notify('resources.applications.notifications.delete_success', 'info', {
                smart_count: 1,
            });
            setDeleting(false);
            history.push('/applications');
        },
        onFailure: error => {
            setDeleting(false);
            notify(error || 'resources.applications.notifications.delete_error', 'error');
        },
    });
    const confirmDelete = event => {
        setDeleteConfirm(true);
    };
    if (!canEdit && !canDelete) {
        return null;
    }
    return (React.createElement(TopToolbar, { className: className },
        React.createElement("div", null,
            canDelete && (React.createElement(Button, { classes: contentLabelClasses, startIcon: React.createElement(DeleteIcon, null), onClick: confirmDelete }, translate('resources.applications.actions.delete'))),
            canEdit && React.createElement(EditButton, { basePath: basePath, record: data })),
        React.createElement(ConfirmDialog, { title: translate('resources.applications.actions.deleteApplication'), content: translate('resources.applications.confirm_delete'), buttonConfirm: translate('resources.applications.actions.delete'), buttonCancel: translate('resources.applications.actions.cancel'), open: deleteConfirm, onConfirm: () => {
                setDeleteConfirm(false);
                setDeleting(true);
                deleteApplication();
            }, onCancel: () => setDeleteConfirm(false) }),
        React.createElement(LoadingDialog, { title: translate('resources.applications.actions.deleting_title'), content: translate('resources.applications.deleting_content'), open: deleting })));
};
export const ApplicationShow = props => {
    const _a = useStyles(props), { root: rootClassName } = _a, classes = __rest(_a, ["root"]);
    const { permissions, id } = props, rest = __rest(props, ["permissions", "id"]);
    const [userContext] = useUserContext();
    return (React.createElement(Show, Object.assign({ className: rootClassName, classes: classes, title: React.createElement(ApplicationTitle, null), id: id, actions: React.createElement(AppShowActions, { userContext: userContext }) }, rest),
        React.createElement(ApplicationDetails, null)));
};
const useStyles = makeStyles(theme => ({
    root: {},
}), {
    name: 'Layer7ApplicationShow',
});
//# sourceMappingURL=ApplicationShow.js.map